'use client'

import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'

export function SandboxToggle({
  checked,
  onCheckedChange,
}: {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
}) {
  return (
    <div className="flex items-center justify-between gap-4 rounded-lg border border-atrium-border bg-white p-4">
      <div className="space-y-1">
        <Label htmlFor="sandbox-mode" className="text-sm font-medium text-atrium-black">
          Sandbox mode (no writes)
        </Label>
        <p className="text-sm text-atrium-black/60">
          Reads run against your real workspace data. Writes are intercepted and shown in the trace.
        </p>
      </div>
      <Switch id="sandbox-mode" checked={checked} onCheckedChange={onCheckedChange} />
    </div>
  )
}
